import React, { useState, useEffect } from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react'
// import { clsx } from 'clsx';

import RundedrehenMapItemsList from './rundedrehen-map-items-list';
import RundedrehenMapMap from './rundedrehen-map-map';
import RundedrehenNewsletterPopup from './rundedrehen-newsletter-popup';

'use strict';

function RundedrehenMapApp() {
  const [loading, setLoading] = useState(false);
  const [itemType, setItemType] = useState('club_event');
  const [mapData, setMapData] = useState([]);
  const [activeItems, setActiveItems] = useState([]);
  const [visibleItems, setVisibleItems] = useState(null);
  // const { trackPageView, trackEvent } = useMatomo();
  const { trackPageView } = useMatomo();


  useEffect(() => {
    getMapData(itemType);
    // Track page view
    trackPageView();
    // // track category change in itemlist
    // trackEvent({ category: 'itemlist', action: 'change', value: itemType });
  }, []);


  const getMapData = (type) => {
    setLoading(true);

    fetch('/map/data/' + type, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (jsonData) {
      setMapData(jsonData);
      setLoading(false);
    });
  }

  const updateItemType = (itemType) => {
    setItemType(itemType);
    getMapData(itemType);
  }

  const setActive = (ids) => {
    setActiveItems(ids);
  }

  const setVisible = (items) => {
    setVisibleItems(items);
  }


  if (mapData.listItems != undefined) {
    return <div className="
      rundedrehen-map h-full overflow-hidden
      flex flex-col md:flex-row
      md:items-end
    ">
      <RundedrehenMapItemsList
        mapData={mapData}
        activeItems={activeItems}
        setActive={setActive}
        visibleItems={visibleItems}
        updateItemType={updateItemType}
        itemType={itemType}
        loading={loading}
      />
      <RundedrehenMapMap
        mapData={mapData}
        activeItems={activeItems}
        setActive={setActive}
        visibleItems={visibleItems}
        itemType={itemType}
        setVisible={setVisible}
        loading={loading}
      />
      <RundedrehenNewsletterPopup
        delay={10000}
      />
    </div>
  }
  else {
    return <div className="
      rundedrehen-map map-wrapper h-full overflow-hidden
      bg-primary text-neutral_d font-bold text-base
      uppercase
      flex justify-center items-center
    ">
      Loading
    </div>
  }


}

export default RundedrehenMapApp;
